import { useState, useEffect, version } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'
import _ from 'lodash'
import { constants } from '../../../Constants/constants'
import { newPost, newPut } from '../../../helper/baseFetch_v2'
import { setAppVersionRestaurant, setAppVersionRestaurantValue } from '../../../actions/appVersionRestaurantAction'
import { formatMultipleSelectArray, standardizeOptions } from '../../../helper/util'
import { validateForm } from '../../../validations/appVersionRestaurantValidation'
import { appVersionListFilters } from '../constants'

export function useAppVersionRestaurantCreate({ deleteMode }) {
    const dispatch = useDispatch()
    const store = useStore()
    const history = useHistory()
    const savedAppVersionRestaurant = useSelector((state) => state.appVersionRestaurant.ui.appVersionRestaurant)
    const lang = useSelector((state) => state.lang.ui.lang)
    const theme = useSelector((state) => state.theme.ui.theme)

    const [clear, setClear] = useState(false)
    const [inputError, setInputError] = useState({})
    const [addRestaurantMap, setAddRestaurantMap] = useState(new Map())
    const [drawerOpen, setDrawerOpen] = useState(false)
    const [drawerAppVersionOpen, setDrawerAppVersionOpen] = useState(false)
    const [drawerTemplateOpen, setDrawerTemplateOpen] = useState(false)
    const [drawerType, setDrawerType] = useState(null)
    const [customFilter, setCustomFilter] = useState(null) //appVersionListFilters
    const [showDialog, setShowDialog] = useState(false)
    const [confirmList, setConfirmList] = useState([])
    const [dialog, setDialog] = useState({ open: false, dialogActions: [] })
    const [warningDialog, setWarningDialog] = useState({ open: false, dialogContent: null, dialogActions: [] })
    const [saveAsTemplateDialog, setSaveAsTemplateDialog] = useState({ open: false, name: '', saving: false })
    const [snackbar, setSnackbar] = useState({ open: false, message: '', type: '' })

    const releaseList = savedAppVersionRestaurant.versionConfigList ?? []

    function onChangeInput(name, e) {
        dispatch(setAppVersionRestaurantValue(name, savedAppVersionRestaurant, '', e))
    }

    function onChangeVersionConfigList(name, value, target) {
        const index = savedAppVersionRestaurant.versionConfigList.findIndex(
        (item) => item.deviceType === target.deviceType && item.buildTarget === target.buildTarget
        )
        const temp = _.cloneDeep(savedAppVersionRestaurant)
        temp.versionConfigList[index][name] = value ?? null
        dispatch(setAppVersionRestaurant(temp))
    }

    function handleFolderMap(id, create = true) {
        const buildTargetList = ['ANDROID_MODERN', 'ANDROID_LEGACY', 'ANDROID_MPOS', 'IOS']
        const temp = _.cloneDeep(savedAppVersionRestaurant)
        if (create) {
        temp.versionConfigList = temp.versionConfigList.concat(
            buildTargetList.map((item) => ({ deviceType: id, buildTarget: item, shopAppReleaseId: null, forceUpdate: false }))
        )
        } else {
        temp.versionConfigList = temp.versionConfigList.filter((item) => item.deviceType !== id)
        }
        dispatch(setAppVersionRestaurant(temp))
    }

    function handleOnClickDrawer(event, page, buildTarget = null) {
        if (event) {
        const isMuiIcon =
            event.target.closest('.MuiAutocomplete-clearIndicator') ||
            event.target.closest('.MuiAutocomplete-popupIndicator')
        if (isMuiIcon) return
        }

        if (page === 'appVersion') {
        if (buildTarget) {
            setDrawerType(buildTarget)
            setCustomFilter([
            ...appVersionListFilters,
            {
                className: 'filter-input',
                label: { resource: 'appVersionRestaurantPage', key: 'status' },
                value: formatMultipleSelectArray(['PILOT', 'STABLE'], constants.CHOICES.APP_VERSION.STATUS),
                type: constants.TYPE.SELECT,
                selectValue: constants.CHOICES.APP_VERSION.STATUS.filter((item) => ['PILOT', 'STABLE'].includes(item.value)),
                name: 'statusList',
                size: constants.SIZE.SMALL,
                multiple: true,
                minSelect: 1,
                disableClearable: true,
            },
            {
                className: 'filter-input',
                label: { resource: 'appVersionRestaurantPage', key: 'buildTarget' },
                value: buildTarget?.buildTarget,
                type: constants.TYPE.SELECT,
                selectValue: standardizeOptions(constants.CHOICES.APP_VERSION.BUILD_TARGET, 'value', 'name'),
                name: 'buildTarget',
                size: constants.SIZE.SMALL,
                disabled: true,
            },
            ])
        }
        setDrawerAppVersionOpen(true)
        return
        } else if (page === 'template') {
            setDrawerTemplateOpen(true)
            // setDrawerOpen(true)
            return
        }

        setAddRestaurantMap(new Map(savedAppVersionRestaurant.restUrlIdList?.map((item) => [item, { restUrlIdList: item }])))
        setDrawerOpen(true)
    }

    function onClickCloseDrawer(page) {
        if (page === 'appVersion') { setDrawerAppVersionOpen(false); return }
        if (page === 'template') { setDrawerTemplateOpen(false); return }
        setDrawerOpen(false)
    }

    function handleRestUrlId() {
        const list = Array.from(addRestaurantMap, ([, value]) => value.restUrlIdList || value.restUrlId)
        const temp = _.cloneDeep(savedAppVersionRestaurant)
        temp.restUrlIdList = list
        dispatch(setAppVersionRestaurant(temp))
        onClickCloseDrawer()
    }

    function applyTemplate(template) {
        const buildTargetList = ['ANDROID_MODERN', 'ANDROID_LEGACY', 'ANDROID_MPOS', 'IOS']
        const temp = _.cloneDeep(savedAppVersionRestaurant)
        const deviceTypes = [...new Set(template.versionConfigList.map((item) => item.deviceType))]
        temp.versionConfigList = deviceTypes.flatMap((deviceType) =>
            buildTargetList.map((buildTarget) => {
                const existing = template.versionConfigList.find(
                    (item) => item.deviceType === deviceType && item.buildTarget === buildTarget
                )
                return existing ? { ...existing, forceUpdate: existing.forceUpdate ?? false } : { deviceType, buildTarget, shopAppReleaseId: null, forceUpdate: false }
            })
        )
        dispatch(setAppVersionRestaurant(temp))
    }

    function onClickListRow(data, page) {
        const temp = _.cloneDeep(savedAppVersionRestaurant)
        if (page === 'appVersion') {
        const index = temp.versionConfigList.findIndex(
            (item) => item.deviceType === drawerType?.deviceType && item.buildTarget === drawerType?.buildTarget
        )
        if (index !== -1) temp.versionConfigList[index].shopAppReleaseId = data ?? null
        } else {
        temp.restUrlId = data.restUrlId
        }
        dispatch(setAppVersionRestaurant(temp))
        onClickCloseDrawer(page)
    }

    async function onClickSave() {
        const { valid, errors } = await validateForm(savedAppVersionRestaurant, deleteMode)
        setInputError(errors || {})
        
        if (!valid) return

        const originalDeviceTypes = [...new Set(releaseList.map((i) => i.deviceType))]
        const deviceTypesAllNull = originalDeviceTypes.filter((dt) => {
            const items = releaseList.filter((i) => i.deviceType === dt)
            return items.length > 0 && items.every((i) => i.shopAppReleaseId == null && i.shopAppRelease == null)
        })

        if (deviceTypesAllNull.length > 0 && !deleteMode) {
        setWarningDialog({
            open: true,
            dialogContent: deviceTypesAllNull,
            dialogActions: [],
        })
        return
        }

        const filterVersionConfigList = deleteMode
        ? releaseList.filter((item) => item?.status === true)
        : releaseList.filter((item) => item.shopAppReleaseId != null || item.shopAppRelease != null)

        setConfirmList({ ...savedAppVersionRestaurant, versionConfigList: filterVersionConfigList })
        setShowDialog(true)
    }

    async function onClickConfirmSave() {
        const formatVersionConfig = confirmList.versionConfigList.map((item) =>
        deleteMode
            ? { deviceType: item.deviceType, buildTarget: item.buildTarget, status: item.status ? 'D' : null }
            : { ...item, shopAppReleaseId: item.shopAppRelease?.id ?? null }
        )
        const data = { ...confirmList, versionConfigList: formatVersionConfig }
        const path = deleteMode
        ? 'gulu-console/merchant/shop-app-version-control-status'
        : 'gulu-console/merchant/shop-app-version-control'

        const method = deleteMode ? newPut : newPost

        method({
        path,
        body: data,
        successCallback: () => {
            setDialog({
            open: true,
            dialogContentText: { key: deleteMode ? 'editSuccess' : 'createSuccess' },
            dialogActions: [
                { label: { key: deleteMode ? 'backEdit' : 'backCreate' }, onClick: onClickBackToCreate },
                { label: { key: 'backList' }, onClick: onClickBackToList },
            ],
            })
            setClear(false)
        },
        store,
        })
    }

    function onClickBackToCreate() {
        setDialog({ open: false, dialogActions: [] })
        setClear(true)
    }

    function onClickBackToList() {
        setDialog({ open: false, dialogActions: [] })
        history.push('/' + constants.PATH.APPVERSION_RESTAURANT.APPVERSION_RESTAURANT)
    }

    function onClickConfirmSaveTemplate(template, templateName) {
        const temp = {
            code: templateName,
            versionConfigList: template.map((item) => ({
                deviceType: item.deviceType,
                buildTarget: item.buildTarget,
                shopAppReleaseId: item.shopAppReleaseId?.id ?? null,
                // forceUpdate: item.forceUpdate,
            })),
        }
        setShowDialog(false)
        setDrawerTemplateOpen(false)
        setSaveAsTemplateDialog({ open: false, name: '', saving: false })
        setSnackbar({ open: true, message: 'Template create successfully', type: 'success' })
        // temp.versionConfigList = temp.versionConfigList.concat(confirmList.versionConfigList)
        // newPost({
        //     path: 'gulu-console/merchant/shop-app-version-control/template',
        //     body: temp,
        //     successCallback: () => {
        //         setShowDialog(false)
        //         setDrawerTemplateOpen(false)
        //         setSnackbar({ open: true, message: 'Template create successfully' })
        //     },
        //     store,
        // })
    }

    useEffect(() => {
        dispatch(setAppVersionRestaurant(constants.APP_VERSION_RESTAURANT_INPUT))
        setClear(false)
        setInputError({})
    }, [clear === true]) // eslint-disable-line react-hooks/exhaustive-deps

    return {
        savedAppVersionRestaurant,
        lang, theme,
        inputError,
        addRestaurantMap, setAddRestaurantMap, setDrawerTemplateOpen,
        drawerOpen, drawerAppVersionOpen, drawerTemplateOpen,
        drawerType,
        customFilter,
        showDialog, setShowDialog,
        confirmList,
        dialog, setDialog,
        warningDialog, setWarningDialog,
        onChangeInput, onChangeVersionConfigList,
        handleFolderMap, handleOnClickDrawer,
        onClickCloseDrawer, handleRestUrlId,
        applyTemplate,
        onClickListRow, onClickSave, onClickConfirmSave,
        saveAsTemplateDialog, setSaveAsTemplateDialog, onClickConfirmSaveTemplate,
        snackbar, setSnackbar
    }
}